import { PackageDeployerFormGzDataProvider } from '../dataProvider/PackageDeployerFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class PackageDeployerFormGzDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PackageDeployerFormGzDataProvider);
  }
}
